import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import { useTranslation } from "react-i18next";
import "leaflet/dist/leaflet.css";
import { Box, Button, Typography } from "@mui/material";
import "../styles/Map.scss";
import L from "leaflet";
import { CiLocationOn } from "react-icons/ci";
import { LiaLongArrowAltRightSolid } from "react-icons/lia";
import { getMapDircetion } from "../helpers/GeoLocationHelper";
import i18n from "../../i18n";
import i18next from "../../i18n";

const position: [number, number] = [25.355297580352715, 55.399926782831564]; // Riyadh, Saudi Arabia

// Fixes Leaflet map resize issue
const ResizeMap = () => {
  const map = useMap();

  useEffect(() => {
    setTimeout(() => {
      map.invalidateSize();
    }, 100);
  }, [map]);
  return null;
};
const customIcon = new L.Icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/128/684/684908.png", // Custom marker image URL
  iconSize: [20, 20], // Size of the icon
  iconAnchor: [20, 20], // Point where the icon is anchored
  popupAnchor: [0, -40], // Position of popup relative to icon
});
const LocationMap = () => {
  const { t } = useTranslation();
  return (
    <Box
      flex={1}
      position={"relative"}
      sx={{
        width: "100%",
        height: "38.5rem", // Responsive height
      }}
    >
      <MapContainer
        center={position}
        className="map"
        zoom={17}
        tapHold={false}
        scrollWheelZoom={false}
        doubleClickZoom={false}
        touchZoom={false}
        zoomControl={false}
        dragging={false}
        boxZoom={false}
        attributionControl={false}
        style={{ width: "100%", height: "100%" }}
      >
        <ResizeMap />
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>'
        />
        <Marker icon={customIcon} position={position}>
          <Popup>
            {" "}
            178 S118, Al Mussalla - Al Gharb - Sharjah - United Arab Emirates📍
          </Popup>
        </Marker>
      </MapContainer>
      <div className="map-info">
        <Typography
          fontFamily={i18next.language === "ar" ? "Somar" : "DM Sans"}
          style={{ fontSize: "1.5rem" }}
          fontWeight={500}
          alignContent={"center"}
          px={"1.5rem"}
          justifyItems={"center"}
          justifyContent={"center"}
        >
          {t("visit_office")}
        </Typography>
        <Typography
          fontFamily={i18next.language === "ar" ? "Somar" : "DM Sans"}
          style={{ fontSize: "1rem" }}
          fontWeight={400}
          alignContent={"center"}
          padding={"1rem"}
          justifyItems={"center"}
          justifyContent={"center"}
        >
          <CiLocationOn size={"1rem"} fontFamily="DM Sans" color="#DBA32C" />{" "}
          {t("office_address")}
        </Typography>
        <Button
          onClick={() => getMapDircetion(position[0], position[1])}
          variant="outlined"
          sx={{
            borderColor: "#E3E3E3",
            display: "flex",
            mx: "1rem",
            fontFamily: i18next.language === "ar" ? "Somar" : "DM Sans",
            textTransform: "none",
            color: "#1B1B1B",
            gap: "1rem",
            py: ".5rem",
            px: "1rem",
          }}
        >
          {t("getDirection")}
          {i18n.language === "en" ? (
            <LiaLongArrowAltRightSolid />
          ) : (
            <LiaLongArrowAltRightSolid
              style={{ transform: "rotate(180deg)" }}
            />
          )}
        </Button>
      </div>
    </Box>
  );
};

export default LocationMap;
